export const EntityTypeEnum = {
  FH: "FH",
  SH: "SH",
};
